export default [
    {
        "login": "jnunemaker",
        "id": 235,
        "node_id": "MDQ6VXNlcjIzNQ==",
        "avatar_url": "https://avatars.githubusercontent.com/u/235?v=4",
        "gravatar_id": "",
        "url": "https://api.github.com/users/jnunemaker",
        "html_url": "https://github.com/jnunemaker",
        "followers_url": "https://api.github.com/users/jnunemaker/followers",
        "following_url": "https://api.github.com/users/jnunemaker/following{/other_user}",
        "gists_url": "https://api.github.com/users/jnunemaker/gists{/gist_id}",
        "starred_url": "https://api.github.com/users/jnunemaker/starred{/owner}{/repo}",
        "subscriptions_url": "https://api.github.com/users/jnunemaker/subscriptions",
        "organizations_url": "https://api.github.com/users/jnunemaker/orgs",
        "repos_url": "https://api.github.com/users/jnunemaker/repos",
        "events_url": "https://api.github.com/users/jnunemaker/events{/privacy}",
        "received_events_url": "https://api.github.com/users/jnunemaker/received_events",
        "type": "User",
        "site_admin": false
    }
]